// import { NavbarComponent } from "../../components/share/NavbarComponent";
import { NavbarSupportSystem } from "../../components/share/NavbarSupportSystem";
import { HeadTitle } from "../../components/share/HeadTitle";
import { ChangeAccountFormComponent } from "../../components/SupportSystem/ChangeAccountFormComponent";
// import { TableLandingSupportComponent } from "../../components/SupportSystem/TableLandingSupportComponent";
import { Footer } from "../../components/share/Footer";


export function ChangeAccountFormContainer() {
    const title = "รายการเปลี่ยนแปลงบัญชีการรับเงินช่วยเหลือหรืออุดหนุน"
    return (
        <div className="page-container bg-landing">
            <NavbarSupportSystem />
            <HeadTitle title={title}></HeadTitle>
            <ChangeAccountFormComponent />
            <Footer />
        </div>
    );
}
